import React from 'react';

import './ScanPackageCell.scss';
import { Button, Typography } from '@mui/material';

import { ScanPackage } from '../../../types/ScanPackageType';

type ScanPackageCellTypes = {
  scanPackage: ScanPackage;
  onPressSubscribe: (scanPackage: ScanPackage) => Promise<void>;
};

const ScanPackageCell: React.FC<ScanPackageCellTypes> = (props) => {
  return (
    <div className={'scan-package-cell-container'}>
      {props.scanPackage.product_id === 'scan_package_25' && (
        <div className='popular-label'>
          <Typography fontSize={15} fontWeight={400} color={'white'}>
            Popular
          </Typography>
        </div>
      )}

      <Typography fontSize={15} fontWeight={700} color='primary'>
        {props.scanPackage.name}
      </Typography>
      <div className={'price-line'}>
        <Typography fontSize={24} fontWeight={700}>
          ${props.scanPackage.cost}
        </Typography>
      </div>
      <div className={'discount-line'}>
        {props.scanPackage.discount !== '' && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
            }}
          >
            <Typography
              fontSize={15}
              color='secondary'
              style={{ paddingRight: 3 }}
            >
              Discount{' '}
            </Typography>
            <Typography fontSize={15} color='#6fcf97'>
              {props.scanPackage.discount}
            </Typography>
          </div>
        )}
      </div>
      <Button
        color='primary'
        variant='contained'
        disableElevation
        onClick={() => props.onPressSubscribe(props.scanPackage)}
        className='buy-button'
      >
        <Typography fontSize={18} color='white' fontWeight={500}>
          Buy
        </Typography>
      </Button>
    </div>
  );
};

export default ScanPackageCell;
